const parseCron = (expression) => {
    const parts = expression.split(' ');
    if (parts.length !== 6) {
        throw new Error('Invalid cron expression');
    }

    const [seconds, minute, hour, dayOfMonth, month, dayOfWeek] = parts;

    let perform = 'week';
    let occurs = [0,0];
    let repeat = [0];
    let frequency = 'Daily';
    const prevValue=(frequency,  repeat, perform, occurs)=>{
        return ({
                frequency: frequency,
                startDate: new Date(),
                timeZone: 'UTC',
                repeat: repeat,
                perform: perform,
                occurs: occurs
            })
        };

    //Daily cron parser
    if (dayOfMonth === '*' && dayOfWeek === '?') {
        frequency="Daily";
        repeat =[0];
    } else if (dayOfMonth === '1/2' && dayOfWeek === '?') {
        frequency="Daily";
        repeat=[1];

    } else if (dayOfMonth === '?' && dayOfWeek === '1-5') {
        frequency="Daily";
        repeat=[2];
    }

    //Weekly cron parser
    else if (dayOfMonth === '?' && dayOfWeek !== '*' && !dayOfWeek.includes('#')) 
    { 
        repeat = dayOfWeek.split(',').map(Number).map(v => v - 1);
        frequency = "Weekly";
    }

    //Monthly cron parser
    else if (dayOfMonth !== '?' && dayOfWeek === '?') {
        // Monthly by day
        perform = 'day';
        occurs = [parseInt(dayOfMonth) - 1, 0];
        repeat = month === '*' ? [] : month.split(',').map(Number);
        frequency="Monthly";
    } 
    else if (dayOfMonth === '?' && dayOfWeek !== '?' && dayOfWeek.includes('#')) {
        // Monthly by week
        perform = 'week';

        const [day, week] = dayOfWeek.split('#');  
        occurs = [
            parseInt(week) - 1,                     
            parseInt(day)                      
        ];                                         

        repeat = month === '*' ? [] : month.split(',').map(Number); // <--- months stay here
        frequency = "Monthly";
    }
    return prevValue(frequency, repeat, perform, occurs);
};



export default parseCron;
